/* eslint-disable max-len */
/* eslint-disable no-useless-escape */
import { Language, CountryData, getLanguageByCode, COUNTRY_DATA, XYChartType } from '@moderepo/mode-app-components';



// Define the set of keys we will be using to store data in local storage
export const LS_KEY_LOGIN_INFO: string = 'Login_Info';
export const LS_KEY_DOWNLOAD_DATA_REQUESTS: string = 'Download_Data_Requests';


// Password rules
export const RESTRICTED_PASSWORD_CHARACTERS = [' ', '\t'];
export const RESTRICTED_PASSWORDS = ['password'];



/**
 * Define the set of languages that the app support
 */
export const SUPPORTED_LANGUAGES: readonly Language[] = [{
    name     : 'language.name.english',
    shortName: 'language.short_name.english',
    code     : 'en',
    locale   : 'en_US',
    locale2  : 'en-US',
}, {
    name     : 'language.name.japanese',
    shortName: 'language.short_name.japanese',
    code     : 'ja',
    locale   : 'ja_JP',
    locale2  : 'ja-JP',
}];



/**
 * Get the default language. We will use the browser's default language if there is one. If not, we use English.
 */
export const DEFAULT_LANGUAGE: Language = ((): Language => {
    // First, try to find the browser's default language and see if it is one of the languages that we support.
    const browserLanguages = navigator.languages || [];

    // Go though all the languages that we support and find one that has a language code that matches the browser's languages
    const browserLanguageLocale: string | undefined = browserLanguages.find((locale: string): boolean => {
        return getLanguageByCode(SUPPORTED_LANGUAGES, locale) !== undefined;
    });

    // The default language will be either the browser language, or English, or the FIRST language in the list which ever match first
    const result: Language = (
        getLanguageByCode(SUPPORTED_LANGUAGES, browserLanguageLocale)
        || getLanguageByCode(SUPPORTED_LANGUAGES, 'en')
        || SUPPORTED_LANGUAGES[0]
    );

    return result;
})();


// Define the list of supported countries code
const supportedCountriesCode = ['US', 'JP'];

// GO through the country data and filter all the countries that are not in the supportedCountriesCode
export const SUPPORTED_COUNTRIES: CountryData[] = COUNTRY_DATA.map((country: any) => {
    return country as CountryData;
}).filter((country: any): boolean => {
    return supportedCountriesCode.includes(country.code2);
});


// Convert SUPPORTED_COUNTRIES array to map so that we can lookup country by code without having to loop through all the countries
export const SUPPORTED_COUNTRIES_JSON = SUPPORTED_COUNTRIES.reduce((result: any, country: CountryData): any => {
    // eslint-disable-next-line no-param-reassign
    result[country.code2] = country;
    return result;
}, {});



export const DEFAULT_COUNTRY = SUPPORTED_COUNTRIES_JSON.US;


// There are a few places where we show "--" when there is no value. Instead of hardcode the string "--", we will make this a constants so that
// it is easier to change later.
export const NO_VALUE = '--';

export const DEFAULT_DECIMAL_PLACES = 3;
export const MIN_DECIMAL_PLACES = 0;
export const MAX_DECIMAL_PLACES = 10;


/**
 * Whenever we define a variable of XYChartType, we need to list all the supported XYChartType like this
 *      const chartType?: XYChartType.LINE | XYChartType.AREA | XYChartType.SCATTER | XYChartType.BAR | XYChartType.STACKED_BAR | undefined;
 * The reason we can't do this "const chartType?: XYChartType;" is because XYChartType has other type that can't be used in most places e.g.
 * XYChartType.AVG_MIN_MAX.
 *
 * Therefore, to optimize this, we will define a new Type which is a combination of basic chart types that Amcharts support. So now we can do this
 *      const chartType?: SupportedXYChart | undefined;
 */
export type BasicXYChart = XYChartType.LINE | XYChartType.AREA | XYChartType.SCATTER | XYChartType.BAR | XYChartType.STACKED_BAR;

// The list of basic chart types that Amcharts supports. We need to create this Array in many places therefore we will define it here so that we
// don't need to create a new array every time we need to use it.
export const BASIC_XY_CHART_TYPES: readonly XYChartType[] = [
    XYChartType.LINE, XYChartType.AREA, XYChartType.SCATTER, XYChartType.BAR, XYChartType.STACKED_BAR,
];
